/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {ClientActivationDTO} from "../../dto/client/ClientActivationDTO";
import {CheckboxField} from "../../../tools/model/form/CheckboxField";

export default class ClientActivationForm extends AbstractForm<ClientActivationDTO> {

    constructor(dto?: ClientActivationDTO) {
        super();

        this.fields.set(ClientActivationDTO.ENABLED, new CheckboxField(
            ClientActivationDTO.ENABLED,
            (t: Translation) => t.enabled,
            () => true,
            Type.CHECKBOX,
            true,
            dto?.enabled,
            false
        ));

        if (dto) super.load(dto);
    }
}
